/* RESPONSIBLE TEAM: team-knowledge-foundations */

import {
  BaseConfig,
  EMOJI_TYPEAHEAD,
  INPUT_RULE_CODE_BLOCK,
  INPUT_RULE_EMOJI,
  INPUT_RULE_ORDERED_NESTED_LIST,
  INPUT_RULE_UNORDERED_NESTED_LIST,
  INPUT_RULE_INLINE_CODE,
} from '@intercom/composer-ember';
import EmbercomFileUploader from './embercom-file-uploader';
import {
  type TextDirection,
  type Analytics,
} from '@intercom/composer-ember/lib/config/composer-config';
import { type UploadConfig } from '@intercom/composer-ember/addon/lib/config/composer-config';

export default class DynamicContentComposerConfig extends BaseConfig {
  upload = {
    allowedImageFileTypes: ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'],
    uploader: EmbercomFileUploader,
  } as UploadConfig;
  typeaheads = [EMOJI_TYPEAHEAD];
  placeholder = 'Start writing…';
  analytics: Analytics;
  allowImplicitMarginParagraphs = false;

  constructor(app: any, textDirection: TextDirection = 'ltr', analytics: Analytics) {
    super();
    this.upload.attrs = { policyUrl: `/apps/${app.id}/uploads` };

    this.textDirection = textDirection;

    this.tools = [
      { name: 'text-formatter' },
      { name: 'anchor-editor' },
      { name: 'image-editor', options: { supportAltAttributeEditing: true } },
      { name: 'video-editor' },
      { name: 'media-toolbar', options: { showListToolbarIcon: true } },
    ];

    this.allowedBlocks = [
      'paragraph',
      'heading',
      'subheading',
      'orderedNestedList',
      'unorderedNestedList',
      'codeBlock',
      'image',
      'video',
      'callout',
      'horizontalRule',
    ];

    this.inputRules = [
      INPUT_RULE_CODE_BLOCK,
      INPUT_RULE_EMOJI,
      INPUT_RULE_ORDERED_NESTED_LIST,
      INPUT_RULE_UNORDERED_NESTED_LIST,
      INPUT_RULE_INLINE_CODE,
    ];

    this.analytics = analytics;
    this.isInteractivityDisabled = false;
  }
}
